export default "__VITE_ASSET__BwrMVu3z__"